<template>
  <CateringHeader />
  <CateringBody />
  <CateringFooter />
</template>

<script>
import CateringHeader from '../molecules/CateringHeader.vue'
import CateringBody from '../molecules/CateringBody.vue'
import CateringFooter from '../molecules/CateringFooter.vue'

export default {
  name: 'CateringView',
  components: {
    CateringHeader,
    CateringBody,
    CateringFooter,
  }
}
</script>
